import { BrowserRouter } from "react-router";
import Router from "~/components/router/Router";
import ReactQueryWrapper from "./components/ReactQueryWrapper";
import { AuthEventHandler } from "./components/AuthEventHandler";
import { Toaster } from "~/components/ui/sonner";
import { TooltipProvider } from "snap-design-system";
import { captureInviteIdFromUrl } from "~/helpers/invite-link.helper";
import "./index.css";

// Captura invite_id da URL antes de qualquer redirect de autenticação
captureInviteIdFromUrl();

const App = () => {
  return (
    <ReactQueryWrapper>
      <TooltipProvider>
        <BrowserRouter>
          <AuthEventHandler />
          <Router />
        </BrowserRouter>
        <Toaster />
      </TooltipProvider>
    </ReactQueryWrapper>
  );
};

export default App;
